"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CollaboratorType;

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _FormControlLabel2 = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _Typography2 = _interopRequireDefault(require("@material-ui/core/Typography"));

var _react = _interopRequireDefault(require("react"));

var _Switch = _interopRequireDefault(require("../../components/Switch"));

var _propTypes = require("../../propTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

CollaboratorType.propTypes = _propTypes.OptionProps;

function CollaboratorType(_ref) {
  var _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options,
      setOptions = _ref.setOptions;
  return /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    pt: 1
  }, /*#__PURE__*/_react["default"].createElement(_FormControlLabel2["default"], {
    label: /*#__PURE__*/_react["default"].createElement(_Typography2["default"], {
      variant: "body2"
    }, "Allow adding multiple collaborators"),
    control: /*#__PURE__*/_react["default"].createElement(_Switch["default"], {
      checked: (options === null || options === void 0 ? void 0 : options.relationship) === "many",
      onChange: function onChange(e) {
        return setOptions(_objectSpread(_objectSpread({}, options), {}, {
          relationship: e.target.checked ? "many" : "one"
        }));
      }
    }),
    style: {
      marginLeft: 0
    }
  }), /*#__PURE__*/_react["default"].createElement(_FormControlLabel2["default"], {
    label: /*#__PURE__*/_react["default"].createElement(_Typography2["default"], {
      variant: "body2"
    }, "Notify collaborators when they\u2019re added"),
    control: /*#__PURE__*/_react["default"].createElement(_Switch["default"], {
      checked: !!(options !== null && options !== void 0 && options.notify),
      onChange: function onChange(e) {
        return setOptions(_objectSpread(_objectSpread({}, options), {}, {
          notify: e.target.checked
        }));
      }
    }),
    style: {
      marginLeft: 0
    }
  }));
}